export const CORE_STATUS_OPTIONS = Object.freeze([
  { value: 'pending', label: 'Pendiente' },
  { value: 'paid', label: 'Pagado' },
]);

export const CORE_FREQUENCY_OPTIONS = Object.freeze([
  { value: 'unique', label: 'Unico' },
  { value: 'monthly', label: 'Mensuales' },
  { value: 'multiple', label: 'Multiples' },
]);
